<template>
  <header>
    <div>
      <span v-if='kirby.site.strings'><span v-html='kirby.site.strings.metaheaderintro'>Welcome to a community of listeners, over</span>&nbsp;<number class='tabular' :format='numberFormat' :from="0" :to="visitors" :duration="0.5" easing="Power4.easeOut" />&nbsp;<span class='fadein' v-html='kirby.site.strings.metaheaderafter'>and growing</span></span>
      <PennLogo />
    </div>
  </header>
</template>

<style scoped type="text/css">
  div {
    height: 3rem;
    width: calc(100% - 8rem);
    max-width: var(--main-max-width);
    margin: 0 auto;
    padding: 0.75rem 1.5rem;
    box-sizing: border-box;
    display: var(--flex-or-not);
    flex-pack: justify;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
    -ms-justify-content: space-between;
    box-align: center;
    flex-item-align: center;
    align-items: center;
    -webkit-align-items: center;
    -ms-align-items: center;
  }

  header {
    background-color: var(--bluemint);
  }

  .tabular {
    display: inline-block;
    text-align: right;
  }

  .fadein {
    animation: fadein 2s;
  }

  @keyframes fadein {
    0% { opacity: 0; }
    75% { opacity: 0; }
    100%   { opacity: 1; }
  }
</style>

<script>
import axios from 'axios';
import Vue from 'vue'
import VueNumber from 'vue-number-animation'
import mixins from '.././mixins.js';

Vue.use(VueNumber)
export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  data: function(){
    return {
      visitors: 0
    }
  },
  methods: {
    numberFormat(number) {
      return parseInt(number).toLocaleString('en');
    },
  },
  mounted: function() {
    const http = axios.create({
      method: 'GET',
      credentials: 'include',
      mode: 'no-cors',
      headers: {
        Accept: '*/*',
      }
    });
    let self = this;
    http.get('analytics').then(response => {
      if(response.data.rows[0].metricValues[0].value){
        self.visitors = response.data.rows[0].metricValues[0].value;
        console.log(self.visitors);
      }
    });
  }
}
</script>
